function splitIntoIntervals(number: number, intervals: number) {
  const intervalSize = number / intervals;
  const result: [number, number][] = [];
  for (let i = 0; i < intervals; i += 1) {
    const start = i * intervalSize;
    const end = (i + 1) * intervalSize;
    result.push([start, end]);
  }
  return result;
}

export default splitIntoIntervals;
